import { useContext } from "react"
import { Text } from "atomize"
import { DateTime } from "luxon"
import LessonTypeLabel from "../atoms/LessonTypeLabel"
import { theme } from "../settings/config"
import { sharedDataContext } from "../providers/sharedData.provider"
import { getNamedPartecipants } from "../utils/func.utils"
import { regularPartecipants } from "../utils/substitutes.utils"

// Chi c'è, per riconoscere la lezione: tipo, giorno e ora, i nomi
function LessonSummary({ lessonData }) {
	const { getLessonType } = useContext(sharedDataContext)
	const start = lessonData.lessonStart?.toDate
		? DateTime.fromJSDate(lessonData.lessonStart.toDate()).setLocale("it")
		: null
	const names = getNamedPartecipants(regularPartecipants(lessonData.partecipants ?? []))
		.map(player => player.playerName.trim().split(" ")[0])
		.join(", ")

	return (
		<Text textSize="caption" textColor={theme.colors.text_light}>
			<LessonTypeLabel
				lessonTypeID={lessonData.lessonType}
				lessonType={getLessonType(lessonData.lessonType)}
				background={theme.colors.background}
			/>
			{start && ` · ${start.toFormat("ccc d LLL, HH:mm")}`}
			{names && ` · ${names}`}
		</Text>
	)
}

export default LessonSummary
